import React from "react";
import { Theme } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import makeStyles from "@material-ui/core/styles/makeStyles";
import LabeledContent from "../../../components/LabeledContent";
import { IServiceByProviderListItemFrontEndModel } from "../types";
import OverflowTooltip from "../../../components/OverflowTooltip/OverflowTooltip";
import { ActionBar } from "../../../components/ActionBar/ActionBar";
import { useWizard } from "../../wizard/context";
import { useServicesConfig } from "../modals/hooks/useServicesConfig";
import { QUERY_KEYS } from "../../../constants";
import { queryCache } from "react-query";

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    padding: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      borderBottom: "1px solid #dfdcd6",
    },
  },
  container: {
    marginTop: "-12px",
    marginBottom: "-12px",
    marginLeft: "-8px",
  },
  buttonsContainer: {
    display: "flex",
    textAlign: "center",
    justifyContent: "space-between",
    alignSelf: "center",
  },
  paper: {
    padding: 25,
  },
}));

export default function ServiceListItem({
  service,
}: {
  service: IServiceByProviderListItemFrontEndModel;
}) {
  const classes = useStyles();

  const { openWizard } = useWizard();
  const { getViewConfig, getEditConfig, getDeleteConfig } = useServicesConfig();

  const { servicesListByProvider } = QUERY_KEYS;

  const viewService = async () => {
    openWizard(getViewConfig(service.id));
  };

  const editService = async () => {
    if (await openWizard(getEditConfig(service.id))) {
      await queryCache.invalidateQueries([servicesListByProvider]);
    }
  };

  const deleteService = async () => {
    if (await openWizard(getDeleteConfig(service.id))) {
      await queryCache.invalidateQueries([servicesListByProvider]);
    }
  };

  return (
    <Grid item xs={12} style={{ paddingBottom: 4 }}>
      <Paper className={classes.paper}>
        <Grid
          container
          spacing={2}
          justify={"space-between"}
          alignItems={"flex-start"}
        >
          <Grid item xs={12} sm={10}>
            <Grid container spacing={2} className={classes.container}>
              <Grid item xs={12} sm={6} md={3} className={classes.content}>
                <LabeledContent label={"Service Type"}>
                  {service.serviceProductType}
                </LabeledContent>
              </Grid>
              <Grid item xs={12} sm={6} md={9} className={classes.content}>
                <LabeledContent label={"Operating Countries"}>
                  <OverflowTooltip text={service.countries} />
                </LabeledContent>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={"auto"}
            className={classes.buttonsContainer}
          >
            <div>
              <ActionBar
                editCallBack={editService}
                editTooltip={"Edit service"}
                viewCallBack={viewService}
                viewTooltip={"View service"}
                deleteCallBack={deleteService}
                deleteTooltip={"Delete service"}
              />
            </div>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
}
